<template>
  <div class="site">
    <MainNavBar v-if="!isMeeting" @logout="$app.logout" />
    <main
      class="my-6 site__content"
      :class="{
        site__padding: !isMeeting,
        'gant-together-body': pathMixin_isMeetingLandingPage,
      }"
    >
      <router-view />
    </main>
    <AutoLogoutTimer
      v-if="$globals.profile.firstName !== ''"
      class="pulled-right"
      @logout="$app.logout"
    />
    <MainFooter v-if="!isMeeting" />
  </div>
</template>

<script>
import MainFooter from "@/components/Layout/Footer.vue";
import MainNavBar from "@/components/Layout/MainNavBar.vue";
import AutoLogoutTimer from "@/components/Layout/AutoLogoutTimer.vue";

export default {
  components: {
    MainFooter,
    MainNavBar,
    AutoLogoutTimer,
  },
  computed: {
    isMeeting() {
      return this.pathMixin_isMeeting || this.pathMixin_isMeetingLandingPage;
    },
  },
};
</script>
